function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * @class Oskari.userinterface.component.GridModel
 *
 * Model object for Oskari.userinterface.component.Grid.
 */
Oskari.clazz.define('Oskari.userinterface.component.GridModel',
/**
 * @method create called automatically on construction
 * @static
 */

function () {
  this.fields = [];
  this.data = [];
  this.idField = null;
}, {
  /**
   * @method addField
   * Adds a field name matching data for more convenient access
   * @private
   * @param {String} field name for a field in data objects
   */
  _addField: function _addField(field) {
    if (!this.idField) {
      // default to first field
      this.idField = field;
    }
    this.fields.push(field);
  },
  /**
   * @method getFields
   * Returns field names that are available in data
   * @return {String[]}
   */
  getFields: function getFields() {
    return this.fields;
  },
  /**
   * Use to assign field order
   * @param {String[]} fields
   */
  setFields: function setFields(fields) {
    this.fields = fields;
  },
  /**
   * @method setIdField
   * If not given, first field in data will be used
   * @param {String} pField name of the field that will be used as an id field
   */
  setIdField: function setIdField(pField) {
    this.idField = pField;
  },
  /**
   * @method getIdField
   * Returns the name of the field that is used as an id field
   * @return {String}
   */
  getIdField: function getIdField() {
    return this.idField;
  },
  /**
   * @method setFirstField
   * Sets the given field name to the first column
   * @param {String} firstField name of the first field
   */
  setFirstField: function setFirstField(firstField) {
    if (this.fields.indexOf(firstField) < 1) {
      // nothing to do
      return;
    }
    this.fields = [firstField].concat(_toConsumableArray(this.fields.filter(function (field) {
      return field !== firstField;
    })));
  },
  /**
   * @method addData
   * Used to accumulate the data array for the model
   * @param {Object} pData
   * @param {Boolean} addMissingFields true if user wants to add new feaute keys to the fields
   */
  addData: function addData(pData, addMissingFields) {
    var me = this,
      key;
    // populate fields array if first data
    if (me.fields.length === 0) {
      for (key in pData) {
        if (pData.hasOwnProperty(key)) {
          me._addField(key);
        }
      }
    }
    // if key is not in fields, add it there
    if (addMissingFields) {
      Object.keys(pData).forEach(function (key) {
        if (!me.fields.includes(key)) {
          me._addField(key);
        }
      });
    }
    this.data.push(pData);
  },
  /**
   * @method getData
   * Returns the model data as array
   * @return {Object[]}
   */
  getData: function getData() {
    return this.data;
  }
});